import React, {useEffect} from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import logo from '../assets/images/logo.webp';
import UserService from "../services/UserService";


const SideBar = (props) => {

    let history = useHistory();
    let location = useLocation();
    let roles = props.roles;

    useEffect(() => {
        console.log("url", location.pathname)
        console.log("props: ", props)
        console.log("roles: ", roles[0].name)
    }, [])


    const logOut = () => {
        UserService.logout();
        history.push('/');
    };

    return (
        <div className="sidebar" data-color="purple" data-background-color="white">
            <div className="logo">
                <a
                    href="#"
                    className="simple-text logo-normal"
                    style={{marginRight: 75}}
                >
                    <img src={logo} width={120} alt="logo"/>
                </a>

            </div>
            <div id="sidebar" className="sidebar-wrapper ps-container ps-theme-default ">

                <ul className="nav aside_div scroll">
                    <li className="nav-item ">
                        <Link active-class="active"
                              className={location.pathname === '/dashboard' ? "nav-link active" : "nav-link"
                              } to="/dashboard">
                            <i className="material-icons">dashboard</i>
                            <p>Dashboard</p>
                        </Link>
                    </li>
                    {/*show buttons depending on roles*/}
                    {props.roles.map((role, i) => (
                        role.name === 'Claims Admin' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                            </>

                        ) || role.name === 'Accountant' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                            </>

                        ) || role.name === 'Assistant Accountant' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                            </>

                        ) || role.name === 'Finance Manager' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                            </>

                        ) ||
                        role.name === 'sysadmin' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/policies' ? "nav-link active" : "nav-link"
                                    } to="/policies">
                                        <i className="fa-solid fa-people-group"/>
                                        <p>Clients</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/agents' || location.pathname === '/managers'
                                        || location.pathname === '/edit-manager' || location.pathname === '/edit-agent'
                                        || location.pathname === '/agent-clients' ? "nav-link active" : "nav-link"
                                        } to="/agents">
                                        <i className="fa-solid fa-users-viewfinder"></i>
                                        <p>Sales Army</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/employers' || location.pathname === '/representatives'
                                        || location.pathname === '/edit-representative' || location.pathname === '/edit-employer' ? "nav-link active" : "nav-link"
                                        } to="/employers">
                                        <i className="fa-solid fa-users-gear"></i>
                                        <p>Aggregators</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/commissions' || location.pathname === '/accident-commissions'
                                        || location.pathname === '/funeral-commissions'
                                        || location.pathname === '/comprehensive-commissions'
                                        || location.pathname === '/savings-commissions' ? "nav-link active" : "nav-link"
                                        } to="/commissions">
                                        <i className="fa fa-percent"/>
                                        <p>Commissions</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/products' || location.pathname === '/edit-product'
                                        || location.pathname === '/view-packages' ? "nav-link active" : "nav-link"
                                        } to="/products">
                                        <i className="fa-solid fa-box-open"></i>
                                        <p>Products</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/policy-holders' || location.pathname === '/allocate-accident'
                                        || location.pathname === '/allocate-funeral' || location.pathname === '/allocate-comprehensive'
                                        || location.pathname === '/allocate-savings' || location.pathname === '/add-policy-holder'
                                        || location.pathname === '/view-policy-holder' || location.pathname === '/edit-policy-holder'
                                        || location.pathname === '/allocate-policy' || location.pathname === '/view-policy'
                                        || location.pathname === '/summary' ? "nav-link active" : "nav-link"
                                        } to="/policy-holders">
                                        <i className="fa fa-address-card"/>
                                        <p>Leads</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/users' || location.pathname === '/view-user' ? "nav-link active" : "nav-link"
                                        } to="/users">
                                        <i className="fa-sharp fa-solid fa-users"></i>
                                        <p>Users</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/log' ? "nav-link active" : "nav-link"
                                        } to="/log">
                                        <i className="fa fa-history"/>
                                        <p>Audit Logs</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/reports' ? "nav-link active" : "nav-link"
                                        } to="/reports">
                                        <i className="fa fa-folder-tree"/>
                                        <p>Reports</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/settings' || location.pathname === '/commissions-settings'
                                        || location.pathname === '/roles' ||
                                        location.pathname === '/permissions' || location.pathname === '/view-permissions'
                                        || location.pathname === '/age-limits' || location.pathname === '/payment-methods' ? "nav-link active" : "nav-link"
                                        } to="/settings">
                                        <i className="fa fa-cog"/>
                                        <p>Settings</p>
                                    </Link>
                                </li>
                            </>
                        ) ||
                        role.name === 'Operations Manager' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/policies' ? "nav-link active" : "nav-link"
                                    } to="/policies">
                                        <i className="fa-solid fa-people-group"/>
                                        <p>Clients</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/agents' || location.pathname === '/managers'
                                        || location.pathname === '/edit-manager' || location.pathname === '/edit-agent'
                                        || location.pathname === '/agent-clients' ? "nav-link active" : "nav-link"
                                        } to="/agents">
                                        <i className="fa-solid fa-users-viewfinder"></i>
                                        <p>Sales Army</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/employers' || location.pathname === '/representatives'
                                        || location.pathname === '/edit-representative' || location.pathname === '/edit-employer' ? "nav-link active" : "nav-link"
                                        } to="/employers">
                                        <i className="fa-solid fa-users-gear"></i>
                                        <p>Aggregators</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/commissions' || location.pathname === '/accident-commissions'
                                        || location.pathname === '/funeral-commissions'
                                        || location.pathname === '/comprehensive-commissions'
                                        || location.pathname === '/savings-commissions' ? "nav-link active" : "nav-link"
                                        } to="/commissions">
                                        <i className="fa fa-percent"/>
                                        <p>Commissions</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/products' || location.pathname === '/edit-product'
                                        || location.pathname === '/view-packages' ? "nav-link active" : "nav-link"
                                        } to="/products">
                                        <i className="fa-solid fa-box-open"></i>
                                        <p>Products</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/policy-holders' || location.pathname === '/allocate-accident'
                                        || location.pathname === '/allocate-funeral' || location.pathname === '/allocate-comprehensive'
                                        || location.pathname === '/allocate-savings' || location.pathname === '/add-policy-holder'
                                        || location.pathname === '/view-policy-holder' || location.pathname === '/edit-policy-holder'
                                        || location.pathname === '/allocate-policy' || location.pathname === '/view-policy'
                                        || location.pathname === '/summary' ? "nav-link active" : "nav-link"
                                        } to="/policy-holders">
                                        <i className="fa fa-address-card"/>
                                        <p>Leads</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/log' ? "nav-link active" : "nav-link"
                                        } to="/log">
                                        <i className="fa fa-history"/>
                                        <p>Audit Logs</p>
                                    </Link>
                                </li>
                                 <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/reports' ? "nav-link active" : "nav-link"
                                        } to="/reports">
                                        <i className="fa fa-folder-tree"/>
                                        <p>Reports</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/settings' || location.pathname === '/commissions-settings'
                                        || location.pathname === '/roles' ||
                                        location.pathname === '/permissions' || location.pathname === '/view-permissions'
                                        || location.pathname === '/age-limits' || location.pathname === '/payment-methods' ? "nav-link active" : "nav-link"
                                        } to="/settings">
                                        <i className="fa fa-cog"/>
                                        <p>Settings</p>
                                    </Link>
                                </li>
                            </>
                        ) ||
                        role.name === 'Chief Executive Officer' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/policies' ? "nav-link active" : "nav-link"
                                    } to="/policies">
                                        <i className="fa-solid fa-people-group"/>
                                        <p>Clients</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/agents' || location.pathname === '/managers'
                                        || location.pathname === '/edit-manager' || location.pathname === '/edit-agent'
                                        || location.pathname === '/agent-clients' ? "nav-link active" : "nav-link"
                                        } to="/agents">
                                        <i className="fa-solid fa-users-viewfinder"></i>
                                        <p>Sales Army</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/employers' || location.pathname === '/representatives'
                                        || location.pathname === '/edit-representative' || location.pathname === '/edit-employer' ? "nav-link active" : "nav-link"
                                        } to="/employers">
                                        <i className="fa-solid fa-users-gear"></i>
                                        <p>Aggregators</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/commissions' || location.pathname === '/accident-commissions'
                                        || location.pathname === '/funeral-commissions'
                                        || location.pathname === '/comprehensive-commissions'
                                        || location.pathname === '/savings-commissions' ? "nav-link active" : "nav-link"
                                        } to="/commissions">
                                        <i className="fa fa-percent"/>
                                        <p>Commissions</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/products' || location.pathname === '/edit-product'
                                        || location.pathname === '/view-packages' ? "nav-link active" : "nav-link"
                                        } to="/products">
                                        <i className="fa-solid fa-box-open"></i>
                                        <p>Products</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/policy-holders' || location.pathname === '/allocate-accident'
                                        || location.pathname === '/allocate-funeral' || location.pathname === '/allocate-comprehensive'
                                        || location.pathname === '/allocate-savings' || location.pathname === '/add-policy-holder'
                                        || location.pathname === '/view-policy-holder' || location.pathname === '/edit-policy-holder'
                                        || location.pathname === '/allocate-policy' || location.pathname === '/view-policy'
                                        || location.pathname === '/summary' ? "nav-link active" : "nav-link"
                                        } to="/policy-holders">
                                        <i className="fa fa-address-card"/>
                                        <p>Leads</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/log' ? "nav-link active" : "nav-link"
                                        } to="/log">
                                        <i className="fa fa-history"/>
                                        <p>Audit Logs</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/settings' || location.pathname === '/commissions-settings'
                                        || location.pathname === '/roles' ||
                                        location.pathname === '/permissions' || location.pathname === '/view-permissions'
                                        || location.pathname === '/age-limits' || location.pathname === '/payment-methods' ? "nav-link active" : "nav-link"
                                        } to="/settings">
                                        <i className="fa fa-cog"/>
                                        <p>Settings</p>
                                    </Link>
                                </li>
                            </>
                        ) || role.name === 'Chief Finance Officer' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/policies' ? "nav-link active" : "nav-link"
                                    } to="/policies">
                                        <i className="fa-solid fa-people-group"/>
                                        <p>Clients</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/agents' || location.pathname === '/managers'
                                        || location.pathname === '/edit-manager' || location.pathname === '/edit-agent'
                                        || location.pathname === '/agent-clients' ? "nav-link active" : "nav-link"
                                        } to="/agents">
                                        <i className="fa-solid fa-users-viewfinder"></i>
                                        <p>Sales Army</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/employers' || location.pathname === '/representatives'
                                        || location.pathname === '/edit-representative' || location.pathname === '/edit-employer' ? "nav-link active" : "nav-link"
                                        } to="/employers">
                                        <i className="fa-solid fa-users-gear"></i>
                                        <p>Aggregators</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/commissions' || location.pathname === '/accident-commissions'
                                        || location.pathname === '/funeral-commissions'
                                        || location.pathname === '/comprehensive-commissions'
                                        || location.pathname === '/savings-commissions' ? "nav-link active" : "nav-link"
                                        } to="/commissions">
                                        <i className="fa fa-percent"/>
                                        <p>Commissions</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/products' || location.pathname === '/edit-product'
                                        || location.pathname === '/view-packages' ? "nav-link active" : "nav-link"
                                        } to="/products">
                                        <i className="fa-solid fa-box-open"></i>
                                        <p>Products</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/policy-holders' || location.pathname === '/allocate-accident'
                                        || location.pathname === '/allocate-funeral' || location.pathname === '/allocate-comprehensive'
                                        || location.pathname === '/allocate-savings' || location.pathname === '/add-policy-holder'
                                        || location.pathname === '/view-policy-holder' || location.pathname === '/edit-policy-holder'
                                        || location.pathname === '/allocate-policy' || location.pathname === '/view-policy'
                                        || location.pathname === '/summary' ? "nav-link active" : "nav-link"
                                        } to="/policy-holders">
                                        <i className="fa fa-address-card"/>
                                        <p>Leads</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/log' ? "nav-link active" : "nav-link"
                                        } to="/log">
                                        <i className="fa fa-history"/>
                                        <p>Audit Logs</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/settings' || location.pathname === '/commissions-settings'
                                        || location.pathname === '/roles' ||
                                        location.pathname === '/permissions' || location.pathname === '/view-permissions'
                                        || location.pathname === '/age-limits' || location.pathname === '/payment-methods' ? "nav-link active" : "nav-link"
                                        } to="/settings">
                                        <i className="fa fa-cog"/>
                                        <p>Settings</p>
                                    </Link>
                                </li>
                            </>
                        ) || role.name === 'Business Analyst' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/policies' ? "nav-link active" : "nav-link"
                                    } to="/policies">
                                        <i className="fa-solid fa-people-group"/>
                                        <p>Clients</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/agents' || location.pathname === '/managers'
                                        || location.pathname === '/edit-manager' || location.pathname === '/edit-agent'
                                        || location.pathname === '/agent-clients' ? "nav-link active" : "nav-link"
                                        } to="/agents">
                                        <i className="fa-solid fa-users-viewfinder"></i>
                                        <p>Sales Army</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/employers' || location.pathname === '/representatives'
                                        || location.pathname === '/edit-representative' || location.pathname === '/edit-employer' ? "nav-link active" : "nav-link"
                                        } to="/employers">
                                        <i className="fa-solid fa-users-gear"></i>
                                        <p>Aggregators</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/commissions' || location.pathname === '/accident-commissions'
                                        || location.pathname === '/funeral-commissions'
                                        || location.pathname === '/comprehensive-commissions'
                                        || location.pathname === '/savings-commissions' ? "nav-link active" : "nav-link"
                                        } to="/commissions">
                                        <i className="fa fa-percent"/>
                                        <p>Commissions</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/products' || location.pathname === '/edit-product'
                                        || location.pathname === '/view-packages' ? "nav-link active" : "nav-link"
                                        } to="/products">
                                        <i className="fa-solid fa-box-open"></i>
                                        <p>Products</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/policy-holders' || location.pathname === '/allocate-accident'
                                        || location.pathname === '/allocate-funeral' || location.pathname === '/allocate-comprehensive'
                                        || location.pathname === '/allocate-savings' || location.pathname === '/add-policy-holder'
                                        || location.pathname === '/view-policy-holder' || location.pathname === '/edit-policy-holder'
                                        || location.pathname === '/allocate-policy' || location.pathname === '/view-policy'
                                        || location.pathname === '/summary' ? "nav-link active" : "nav-link"
                                        } to="/policy-holders">
                                        <i className="fa fa-address-card"/>
                                        <p>Leads</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/log' ? "nav-link active" : "nav-link"
                                        } to="/log">
                                        <i className="fa fa-history"/>
                                        <p>Audit Logs</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/settings' || location.pathname === '/commissions-settings'
                                        || location.pathname === '/roles' ||
                                        location.pathname === '/permissions' || location.pathname === '/view-permissions'
                                        || location.pathname === '/age-limits' || location.pathname === '/payment-methods' ? "nav-link active" : "nav-link"
                                        } to="/settings">
                                        <i className="fa fa-cog"/>
                                        <p>Settings</p>
                                    </Link>
                                </li>
                            </>
                        ) || role.name === 'Acturial Analyst' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/policies' ? "nav-link active" : "nav-link"
                                    } to="/policies">
                                        <i className="fa-solid fa-people-group"/>
                                        <p>Clients</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/agents' || location.pathname === '/managers'
                                        || location.pathname === '/edit-manager' || location.pathname === '/edit-agent'
                                        || location.pathname === '/agent-clients' ? "nav-link active" : "nav-link"
                                        } to="/agents">
                                        <i className="fa-solid fa-users-viewfinder"></i>
                                        <p>Sales Army</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/employers' || location.pathname === '/representatives'
                                        || location.pathname === '/edit-representative' || location.pathname === '/edit-employer' ? "nav-link active" : "nav-link"
                                        } to="/employers">
                                        <i className="fa-solid fa-users-gear"></i>
                                        <p>Aggregators</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/commissions' || location.pathname === '/accident-commissions'
                                        || location.pathname === '/funeral-commissions'
                                        || location.pathname === '/comprehensive-commissions'
                                        || location.pathname === '/savings-commissions' ? "nav-link active" : "nav-link"
                                        } to="/commissions">
                                        <i className="fa fa-percent"/>
                                        <p>Commissions</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/products' || location.pathname === '/edit-product'
                                        || location.pathname === '/view-packages' ? "nav-link active" : "nav-link"
                                        } to="/products">
                                        <i className="fa-solid fa-box-open"></i>
                                        <p>Products</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/policy-holders' || location.pathname === '/allocate-accident'
                                        || location.pathname === '/allocate-funeral' || location.pathname === '/allocate-comprehensive'
                                        || location.pathname === '/allocate-savings' || location.pathname === '/add-policy-holder'
                                        || location.pathname === '/view-policy-holder' || location.pathname === '/edit-policy-holder'
                                        || location.pathname === '/allocate-policy' || location.pathname === '/view-policy'
                                        || location.pathname === '/summary' ? "nav-link active" : "nav-link"
                                        } to="/policy-holders">
                                        <i className="fa fa-address-card"/>
                                        <p>Leads</p>
                                    </Link>
                                </li>
                            </>
                        ) || role.name === 'Marketing Manager' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/policies' ? "nav-link active" : "nav-link"
                                    } to="/policies">
                                        <i className="fa-solid fa-people-group"/>
                                        <p>Clients</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/agents' || location.pathname === '/managers'
                                        || location.pathname === '/edit-manager' || location.pathname === '/edit-agent'
                                        || location.pathname === '/agent-clients' ? "nav-link active" : "nav-link"
                                        } to="/agents">
                                        <i className="fa-solid fa-users-viewfinder"></i>
                                        <p>Sales Army</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/employers' || location.pathname === '/representatives'
                                        || location.pathname === '/edit-representative' || location.pathname === '/edit-employer' ? "nav-link active" : "nav-link"
                                        } to="/employers">
                                        <i className="fa-solid fa-users-gear"></i>
                                        <p>Aggregators</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/payments' || location.pathname === '/add-payment'
                                        || location.pathname === '/bulk-payments' ? "nav-link active" : "nav-link"
                                        } to="/payments">
                                        <i className="fa-sharp fa-solid fa-cash-register"></i>
                                        <p>Receipts</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/commissions' || location.pathname === '/accident-commissions'
                                        || location.pathname === '/funeral-commissions'
                                        || location.pathname === '/comprehensive-commissions'
                                        || location.pathname === '/savings-commissions' ? "nav-link active" : "nav-link"
                                        } to="/commissions">
                                        <i className="fa fa-percent"/>
                                        <p>Commissions</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/products' || location.pathname === '/edit-product'
                                        || location.pathname === '/view-packages' ? "nav-link active" : "nav-link"
                                        } to="/products">
                                        <i className="fa-solid fa-box-open"></i>
                                        <p>Products</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/policy-holders' || location.pathname === '/allocate-accident'
                                        || location.pathname === '/allocate-funeral' || location.pathname === '/allocate-comprehensive'
                                        || location.pathname === '/allocate-savings' || location.pathname === '/add-policy-holder'
                                        || location.pathname === '/view-policy-holder' || location.pathname === '/edit-policy-holder'
                                        || location.pathname === '/allocate-policy' || location.pathname === '/view-policy'
                                        || location.pathname === '/summary' ? "nav-link active" : "nav-link"
                                        } to="/policy-holders">
                                        <i className="fa fa-address-card"/>
                                        <p>Leads</p>
                                    </Link>
                                </li>
                            </>
                        ) || role.name === 'Client Delight Assistant' && (
                            <>

                                <li className="nav-item">
                                    <Link className={location.pathname === '/policies' ? "nav-link active" : "nav-link"
                                    } to="/policies">
                                        <i className="fa-solid fa-people-group"/>
                                        <p>Clients</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/agents' || location.pathname === '/managers'
                                        || location.pathname === '/edit-manager' || location.pathname === '/edit-agent'
                                        || location.pathname === '/agent-clients' ? "nav-link active" : "nav-link"
                                        } to="/agents">
                                        <i className="fa-solid fa-users-viewfinder"></i>
                                        <p>Sales Army</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/employers' || location.pathname === '/representatives'
                                        || location.pathname === '/edit-representative' || location.pathname === '/edit-employer' ? "nav-link active" : "nav-link"
                                        } to="/employers">
                                        <i className="fa-solid fa-users-gear"></i>
                                        <p>Aggregators</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/products' || location.pathname === '/edit-product'
                                        || location.pathname === '/view-packages' ? "nav-link active" : "nav-link"
                                        } to="/products">
                                        <i className="fa-solid fa-box-open"></i>
                                        <p>Products</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/policy-holders' || location.pathname === '/allocate-accident'
                                        || location.pathname === '/allocate-funeral' || location.pathname === '/allocate-comprehensive'
                                        || location.pathname === '/allocate-savings' || location.pathname === '/add-policy-holder'
                                        || location.pathname === '/view-policy-holder' || location.pathname === '/edit-policy-holder'
                                        || location.pathname === '/allocate-policy' || location.pathname === '/view-policy'
                                        || location.pathname === '/summary' ? "nav-link active" : "nav-link"
                                        } to="/policy-holders">
                                        <i className="fa fa-address-card"/>
                                        <p>Leads</p>
                                    </Link>
                                </li>

                            </>
                        )
                        || role.name === 'auditor' && (
                            <li className="nav-item">
                                <Link className={location.pathname === '/log' ? "nav-link active" : "nav-link"
                                } to="/log">
                                    <i className="fa fa-history"/>
                                    <p>Audit Logs</p>
                                </Link>
                            </li>
                        )
                        || role.name === 'Policy Admin' && (
                            <>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/claims'
                                    || location.pathname === '/accident-claims' || location.pathname === '/accident-death-claims'
                                    || location.pathname === '/accident-injury-claims' || location.pathname === '/comprehensive-claims'
                                    || location.pathname === '/funeral-claims' || location.pathname === '/savings-claims'
                                    || location.pathname === '/savings-death-claims' || location.pathname === '/savings-refunds'
                                    || location.pathname === '/savings-surrenders' || location.pathname === '/savings-withdrawals'
                                    || location.pathname === '/add-accident-injury-claim' || location.pathname === '/add-accident-death-claim'
                                    || location.pathname === '/add-comprehensive-claim' || location.pathname === '/add-funeral-claim'
                                    || location.pathname === '/add-savings-death-claim' || location.pathname === '/add-refund'
                                    || location.pathname === '/add-savings-surrender' || location.pathname === '/add-partial-withdrawal'
                                    || location.pathname === '/edit-accident-injury-claim' || location.pathname === '/edit-accident-death-claim'
                                    || location.pathname === '/edit-comprehensive-claim' || location.pathname === '/edit-funeral-claim'
                                    || location.pathname === '/edit-savings-death-claim' || location.pathname === '/edit-refund'
                                    || location.pathname === '/edit-savings-surrender' || location.pathname === '/edit-partial-withdrawal' ? "nav-link active" : "nav-link"
                                    } to="/claims">
                                        <i className="fa-solid fa-basket-shopping"></i>
                                        <p>Benefits</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={location.pathname === '/policies' ? "nav-link active" : "nav-link"
                                    } to="/policies">
                                        <i className="fa-solid fa-people-group"/>
                                        <p>Clients</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/agents' || location.pathname === '/managers'
                                        || location.pathname === '/edit-manager' || location.pathname === '/edit-agent'
                                        || location.pathname === '/agent-clients' ? "nav-link active" : "nav-link"
                                        } to="/agents">
                                        <i className="fa-solid fa-users-viewfinder"></i>
                                        <p>Sales Army</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/employers' || location.pathname === '/representatives'
                                        || location.pathname === '/edit-representative' || location.pathname === '/edit-employer' ? "nav-link active" : "nav-link"
                                        } to="/employers">
                                        <i className="fa-solid fa-users-gear"></i>
                                        <p>Aggregators</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/products' || location.pathname === '/edit-product'
                                        || location.pathname === '/view-packages' ? "nav-link active" : "nav-link"
                                        } to="/products">
                                        <i className="fa-solid fa-box-open"></i>
                                        <p>Products</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className={location.pathname === '/policy-holders' || location.pathname === '/allocate-accident'
                                        || location.pathname === '/allocate-funeral' || location.pathname === '/allocate-comprehensive'
                                        || location.pathname === '/allocate-savings' || location.pathname === '/add-policy-holder'
                                        || location.pathname === '/view-policy-holder' || location.pathname === '/edit-policy-holder'
                                        || location.pathname === '/allocate-policy' || location.pathname === '/view-policy'
                                        || location.pathname === '/summary' ? "nav-link active" : "nav-link"
                                        } to="/policy-holders">
                                        <i className="fa fa-address-card"/>
                                        <p>Leads</p>
                                    </Link>
                                </li>
                            </>
                        )
                    ))}

                    <li className="nav-item">
                        <Link className="nav-link" onClick={logOut}>
                            <i className="fa fa-sign-out"/>
                            <p>Logout</p>
                        </Link>
                    </li>
                </ul>


                <div className="ps-scrollbar-x-rail" style={{left: 0, bottom: 0}}>
                    <div
                        className="ps-scrollbar-x"
                        tabIndex="0"
                        style={{left: 0, width: 0}}
                    />
                </div>
                <div className="ps-scrollbar-y-rail" style={{top: 0, right: 0}}>
                    <div
                        className="ps-scrollbar-y"
                        tabIndex={0}
                        style={{top: 0, height: 0}}
                    />
                </div>
            </div>
            <div className="sidebar-background"/>
        </div>
    )
}

export default SideBar;
